import { createHead } from "@vueuse/head";

const head = createHead();

export default function (app) {
  app.use(head);
}
